(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockZusammenfassung', {
            require: {
                form: '^form'
            },
            bindings: {
                onClose: '&abzOnClose',
                options: '<abzOptions'
            },
            templateUrl: 'bloecke/zusammenfassung/blockZusammenfassung.html',
            controller: BlockZusammenfassungController,
            controllerAs: 'zusammenfassungVm'
        });

    BlockZusammenfassungController.$inject = [
        '$modal',
        '$element',
        'mediaQueries',
        'AngebotModel',
        'HtmlUtilsService',
        'FormFieldUtilsService'
    ];
    function BlockZusammenfassungController($modal, $element, mediaQueries, AngebotModel, HtmlUtilsService, FormFieldUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.showZusammenfassung = showZusammenfassung;

        function onInit() {
            activate();
        }

        function activate() {
            vm.options = vm.options || {};
            vm.angebotModel = AngebotModel.get();
        }

        function showZusammenfassung($event) {
            $event.preventDefault();

            if (!vm.form.$valid) {
                FormFieldUtilsService.validate(vm.form, '$$controls', {
                    setTouched: true,
                    setIsSubmitted: true
                });
                return;
            }

            var modalCls = (mediaQueries.small() || mediaQueries.medium()) && !mediaQueries.large() ? 'xlarge' : 'large',
                modalZusammenfassung = $modal.open({
                    templateUrl: 'modal/modalZusammenfassung.html',
                    windowClass: modalCls + ' modal-zusammenfassung',
                    controller: 'ModalZusammenfassungController',
                    controllerAs: 'modalVm',
                    resolve: { /* @ngInject */
                        options: [function () {
                            return vm.options;
                        }]
                    }
                });

            modalZusammenfassung.result.then(function () {
            }).catch(function (error) {
            }).finally(function () {
                vm.onClose();
                focusElementAfterCloseModal();
            });
        }

        function focusElementAfterCloseModal() {
            var el;

            if (!$element || !$element[0] || !$element[0].querySelector('a')) {
                return;
            }

            el = $element[0].querySelector('a');

            el.focus();
            HtmlUtilsService.scrollIntoViewIfNeeded(el);
        }
    }

})();
